import { AUTHENTICATION_V2_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useCallback } from 'react'

export enum IthacaRelatedPlanId {
  AMEX_DESIGN = 'amex_design'
}

interface UseAddUserToPlanExtra {
  addUserToPlanExtra: (ithacaRelatedPlanId: IthacaRelatedPlanId) => Promise<void>
}

export function useAddUserToPlanExtra(): UseAddUserToPlanExtra {
  const { jwt } = useAuthState()
  const addUserToPlanExtra = useCallback(
    async (ithacaRelatedPlanId: IthacaRelatedPlanId): Promise<void> => {
      const token = jwt?.token
      const ithacaId = jwt?.ithacaId
      try {
        if (!ithacaRelatedPlanId || !token || !ithacaId) {
          throw new Error('Unable to attach plan')
        } else {
          await fetch(`${AUTHENTICATION_V2_ENDPOINT}/user/`, {
            method: 'PATCH',
            body: JSON.stringify({
              ithacaId,
              roleNames: [`personal_extra:${ithacaRelatedPlanId}`]
            }),
            headers: {
              authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          })
        }
      } catch (err) {
        console.error(err)
      }
    },
    [jwt]
  )

  return {
    addUserToPlanExtra
  }
}
